module.exports = __webpack_public_path__ + "img/kak-mob.7633b4fc.png";